function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblemaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 444 263",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.60382,-0.60382,0.60382,-0.60382,-5290.88,11680.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5074.5,13845.5C5074.5,13845.5 5137,13879.9 5137,13924.5C5137,13959 5108.99,13987 5074.5,13987C5040.01,13987 5012,13959 5012,13924.5C5012,13879.9 5074.5,13845.5 5074.5,13845.5Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.76656,-0.44258,0.44258,0.76656,-9638.51,-8272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4796.35,13671.2C4796.35,13628.2 4856.64,13595 4856.64,13595C4856.64,13595 4916.94,13628.2 4916.94,13671.2L4916.94,13867.3C4916.94,13900.6 4889.92,13927.6 4856.64,13927.6C4823.36,13927.6 4796.35,13900.6 4796.35,13867.3L4796.35,13671.2Z",
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.76656,-0.44258,0.44258,0.76656,-9469.69,-8272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4796.35,13671.2C4796.35,13628.2 4856.64,13595 4856.64,13595C4856.64,13595 4916.94,13628.2 4916.94,13671.2L4916.94,13867.3C4916.94,13900.6 4889.92,13927.6 4856.64,13927.6C4823.36,13927.6 4796.35,13900.6 4796.35,13867.3L4796.35,13671.2Z",
    style: {
      fill: "url(#_Linear3)"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.66358e-15,-141.487,141.487,8.66358e-15,5074.5,13987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(111,23,186)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(176,56,250)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.03654e-14,-332.592,332.592,2.03654e-14,4856.64,13927.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(196,27,175)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(245,37,134)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.03654e-14,-332.592,332.592,2.03654e-14,4856.64,13927.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(48,84,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,164,252)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblemaps);
export default __webpack_public_path__ + "static/media/bubblemaps.6748e0ea4c9d28e43f14578e380482f5.svg";
export { ForwardRef as ReactComponent };